import React, { useState } from 'react';
import styled from 'styled-components';

interface Props {
  description: string;
}

export const CandidatreeDescription: React.FC<Props> = ({ description }) => {
  const [isOpen, setIsOpen] = useState(false);
  if (!description) return null;

  return (
    <Container>
      {isOpen ? <div>{description}</div> : <Summary>{description}</Summary>}
      <ButtonContainer>
        <MoreButton type={'button'} onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
          {isOpen ? '접기' : '더보기'}
        </MoreButton>
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.2rem;

  > div {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 160%;
    color: var(--mono-60);
  }
`;

const Summary = styled.div`
  max-lines: 1;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const MoreButton = styled.button<{ isOpen: boolean }>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.4rem;

  color: var(--mono-60);
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 160%;

  &:after {
    content: '';
    width: 1.6rem;
    height: 1.6rem;
    background-image: url('/images/common/chevron.svg');
    background-size: cover;
    transform: rotate(${props => (props.isOpen ? '90deg' : '270deg')});
  }
`;
